var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{attrs:{"for":_vm.customRef}},[_vm._v(_vm._s(_vm.label))]),_c('vue-dropzone',{ref:_vm.customRef,staticClass:"d-flex justify-content-center align-items-center",style:({
            border: _vm.error ? '1px solid red' : '',
            color: _vm.error ? 'red' : ''
        }),attrs:{"id":_vm.customRef,"options":_vm.dropzoneOptions},on:{"vdropzone-complete":_vm.changeImage,"vdropzone-removed-file":_vm.onImageRemoved}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }